import { render, staticRenderFns } from "./WarningBanner.vue?vue&type=template&id=194ccf10&scoped=true&"
import script from "./WarningBanner.vue?vue&type=script&lang=js&"
export * from "./WarningBanner.vue?vue&type=script&lang=js&"
import style0 from "./WarningBanner.vue?vue&type=style&index=0&id=194ccf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ccf10",
  null
  
)

export default component.exports
import {QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign({QCardSection,QIcon}, component.options.components || {})
